import React from 'react'
import classNames from 'classnames'

function PrimaryButton({ label, size, fullWidth, onClick, modifierClasses = [] }) {

  const classes = classNames(
    'button',
    'button--primary',
    {
      'button--tiny': size === 'tiny',
      'button--small': size === 'small',
    },
    {
      'u-width-full': fullWidth,
    },
    modifierClasses
  )

  return (
    <button
      onClick={onClick}
      className={classes}
    >
      {label}
    </button>
  )
}

export default PrimaryButton
